import PropTypes from "prop-types";
import React from "react";
import { cn } from "utils";

const LazyLoadingSpinner = ({ className = "", text = "Loading..." }) => {
  return (
    <div className={cn("tw-flex tw-items-center tw-justify-center tw-min-h-screen tw-bg-primary", className)}>
      <div className="tw-text-center">
        <div className="tw-inline-block tw-animate-spin tw-rounded-full tw-h-12 tw-w-12 tw-border-b-2 tw-border-white tw-mb-4"></div>
        <p className="tw-text-white tw-text-lg">{text}</p>
      </div>
    </div>
  );
};

LazyLoadingSpinner.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
};

export default LazyLoadingSpinner;
